<template>
  <div>
    <iframe :src="htmllink" width="100%" height="100%" onload='javascript:(function(o){o.style.height=o.contentWindow.document.body.scrollHeight+50+"px";}(this));'
    style="height: 100vh; width: 100%; border: none; overflow: hidden"></iframe>
  </div>
</template>
<script>
import { mapActions } from "vuex";


export default {
  name: "PartnerDirectoryView",
  data() {
    return {
      htmlContent: "",
    };
  },
  computed: {
    htmllink() {
      const link = this.$route.query?.link
      return link;
    },
  },
  mounted() {
    this.scrollTop();
    this.convertHTMLtoDoc(this.htmllink);
  },
  methods: {
    ...mapActions(["scrollTop"]),
    convertHTMLtoDoc(url) {
      fetch(url)
        .then((response) => response.text())
        .then((data) => {
          this.htmlContent = data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped></style>
